import DelaysManager from "../../pages/delays/manager";
import DelaysParetoReport from "../../pages/delays/pareto";
import DelaysReport from "../../pages/delays/report";
import DelaysSankeyReport from "../../pages/delays/sankey";

export const routeDelaysManager = "/delays/manager";
export const routeDelaysReport = "/delays/report";
export const routeDelaysPareto = "/delays/pareto";
export const routeDelaysSankey = "/delays/sankey";

export const delayRoutes = [
	{
		path: `${routeDelaysManager}`,
		element: <DelaysManager />,
		permission: "ui.navbar.delays.manager",
	},
	{
		path: `${routeDelaysManager}/:shiftId`,
		element: <DelaysManager />,
		permission: "ui.navbar.delays.manager",
	},
	{
		path: `${routeDelaysReport}`,
		element: <DelaysReport />,
		permission: "ui.navbar.delays.report",
	},
	{
		path: `${routeDelaysPareto}`,
		element: <DelaysParetoReport />,
		permission: "ui.navbar.delays.pareto",
	},
	{
		path: `${routeDelaysSankey}`,
		element: <DelaysSankeyReport />,
		permission: "ui.navbar.delays.sankey",
	},
];
